import styled, { keyframes } from "styled-components";

const rotate = keyframes`
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
`;

export const Spnr = styled.span`
    display: inline-block;
    position: absolute;
    width: 20px;
    height: 20px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    span{
        box-sizing: border-box;
        display: block;
        position: absolute;
        width: 100%;
        height: 100%;
        border: 2px solid transparent;
        border-radius: 50%;
        animation: ${rotate} 1.2s linear infinite;
        border-color: #fff transparent transparent transparent;
    }
    ${p => p.theme === 'white' && `
        span{
            border-color: #fff transparent transparent transparent;
        }
    `}
    ${p => p.theme === 'blue' && `
        span{
            border-color: #008cff transparent transparent transparent;
        }
    `}
    span:nth-child(1) {
        animation-delay: -0.45s;
    }
    span:nth-child(2) {
        animation-delay: -0.3s;
    }
    span:nth-child(3) {
        animation-delay: -0.15s;
    }
`;